import { Injectable } from '@angular/core';
import { SelectedOfferService } from './section-services/selected-offer/selected-offer.service';
import { AdditionalInformationStateService } from './section-services/additional-information/additional-information-state.service';
import { DialogService } from '../dialog.service';
import { AdditionalInformationSectionConsts } from '../../../shared/sections/web/additional-information-section/additional-information-section.consts';
import { DialogKey } from '../../../shared/components/dialogs/dialogs-configuration';

@Injectable({
  providedIn: 'root'
})
export class ProamaExceptionService {

  constructor(private selectedOfferService: SelectedOfferService,
              private additionalInformationStateService: AdditionalInformationStateService,
              private dialogService: DialogService) {
  }

  isValid(): boolean {
    if (this.selectedOfferService.hasACOrACMini() && (!this.hasImmobilizer())) {
      this.openExceptionDialog();
      return true;
    } else {
      return false;
    }
  }

  private hasImmobilizer(): boolean {
    return this.findQuestionByCode(AdditionalInformationSectionConsts.IMMOBILIZER);
  }

  private findQuestionByCode(code: string): boolean {
    try {
      return this.additionalInformationStateService.vehicleData.questions.find(({ questionCode }) => questionCode.toLowerCase() === code.toLowerCase()).questionAnswer.toUpperCase().endsWith('YES');
    } catch {
      return false;
    }
  }

  private openExceptionDialog(): void {
    this.dialogService.open(DialogKey.MISSING_ANTITHEFT_DEVICE_EXCEPTION);
  }
}
